/**
 * "Add" buttons on the pairs suggested in the bag (snippets/mlb-multibuy.liquid, cart mode).
 *
 * Each button carries the variant already matched to the shopper's size, so one tap adds it.
 * The add follows the product form's own path: announce the cart change, post to the cart with
 * the bag's section ids, then resolve the event with the fresh cart and section HTML so the bag,
 * its totals and the header count re-render together. The bag re-renders without running inline
 * scripts, so clicks are picked up on the document.
 */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-mlb-bag-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.getAttribute('aria-busy') === 'true') return;
  event.preventDefault();

  const variantId = button.dataset.mlbBagAdd;
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component'), (el) =>
    el instanceof HTMLElement ? el.dataset.sectionId : ''
  ).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();

  button.setAttribute('aria-busy', 'true');
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines: [{ merchandiseId: String(variantId), quantity: 1 }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const result = await response.json();
    const cart = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) =>
      r.json()
    );

    if (!response.ok || result.status) {
      button.dispatchEvent(
        new CartErrorEvent({ error: result.description || result.message || 'Add to bag failed', code: 'INVALID' })
      );
      button.disabled = true;
      button.querySelector('.mlb-mb__add-label')?.replaceChildren('Unavailable');
    }

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        sections: result.sections,
        source: 'mlb-bag-add',
        itemCount: 1,
        didError: Boolean(result.status),
      },
    });
  } catch (error) {
    deferred.reject(error);
  } finally {
    button.removeAttribute('aria-busy');
  }
});
